<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
      </v-flex>

      <v-flex xs12>
        <v-card class="mt-4">
          <v-card-text class="text-center">
            <v-container fluid grid-list-md>
              <v-layout>
                <h2 class="heading">
                  <font-awesome-icon size="3x" icon="user-tie"></font-awesome-icon>
                  <br>
                  {{ $t('verifyTaxDetails') }}
                </h2>
              </v-layout>

            </v-container>
          </v-card-text>

          <div class="verify-actions">
            <v-btn color="primary" @click="goTo('taxFiscalDataForm')">{{ $t('verifyFiscalBtn') }}</v-btn>
            <v-btn color="primary" @click="createShipment" :disabled="($auth.currentUser.total_shipments > 0 || $auth.currentUser.balance < 0)">{{ $t('demoShipmentBtn') }}</v-btn>
            <v-btn color="primary" @click="goTo('newStore')">{{ $t('integrateStores') }}</v-btn>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style type="text/css">
  .heading {
    width: 100%;
    text-align: center;
  }
  .verify-actions {
    text-align: center;
    padding: 30px;
  }
</style>

<script>

export default {
  name: 'TaxFiscalDatum',

  props: {},

  data () {
    return {
      loading: false
    }
  },

  components: {
  },

  computed: {
  },

  methods: {
    async submit () {
    },

    createShipment () {

      window.sessionStorage.removeItem('new_shipment')
      this.goTo('newShipment')
    }
  },

  watch: {
  },

  async mounted () {
    await this.$auth.getCurrentUser()
  }
}
</script>
